import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-videos',
    templateUrl: './videos.component.html',
    styleUrls: ['./videos.component.scss'],
    imports:[RouterModule]
})
export class VideosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
